import React, { Component } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import Badge from "react-bootstrap/Badge";

// Custom styles
const styles = {
  sectionTitle: {
    color: "#222",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    textAlign: "center",
    marginBottom: "40px",
    position: "relative",
  },
  timelineElement: {
    borderLeft: "5px solid",
    borderImage: "linear-gradient(180deg, #AE944F, #f0c27b) 1",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    transition: "transform 0.3s ease-in-out",
  },
  timelineElementHover: {
    transform: "scale(1.02)",
  },
  iconStyle: {
    background: "linear-gradient(45deg, #AE944F, #f0c27b)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem",
    animation: "pulse 2s infinite",
  },
  mainBadge: {
    background: "#f0c27b",
    border: "none",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "box-shadow 0.2s ease",
  },
  techBadge: {
    background: "#AE944F",
    border: "none",
    cursor: "pointer",
    transition: "box-shadow 0.2s ease",
  },
};

// Keyframes for pulse animation (added to global CSS)
// You can include this in your main CSS file.
const globalStyles = `
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}
.main-badge:hover, .experience-badge:hover {
  box-shadow: 0 0 8px rgba(0,0,0,0.3);
}
.vertical-timeline-element:hover {
  transform: scale(1.02);
}
`;

class Experience extends Component {
  componentDidMount() {
    // Append global CSS for keyframes and hover effects
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = globalStyles;
    document.head.appendChild(styleSheet);
  }

  render() {
    const { resumeExperience, resumeBasicInfo } = this.props;

    if (resumeExperience && resumeBasicInfo) {
      const sectionName = resumeBasicInfo.section_name.experience;
      var work = resumeExperience.map((work, i) => {
        const technologies = work.technologies;
        const mainTechnologies = work.mainTech;

        const mainTech = mainTechnologies.map((technology, idx) => {
          return (
            <Badge
              pill
              className="main-badge mr-2 mb-2"
              key={idx}
              style={styles.mainBadge}
            >
              {technology}
            </Badge>
          );
        });
        const tech = technologies.map((technology, idx) => {
          return (
            <Badge
              pill
              className="experience-badge mr-2 mb-2"
              key={idx}
              style={styles.techBadge}
            >
              {technology}
            </Badge>
          );
        });
        return (
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={work.years}
            iconStyle={styles.iconStyle}
            icon={<i className="fab fa-react experience-icon"></i>}
            contentStyle={styles.timelineElement}
            key={i}
          >
            <div style={{ textAlign: "left", marginBottom: "4px" }}>
              {mainTech}
            </div>

            <h3
              className="vertical-timeline-element-title"
              style={{
                textAlign: "left",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              }}
            >
              {work.title}
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              style={{
                textAlign: "left",
                fontStyle: "italic",
                color: "#555",
              }}
            >
              {work.company}
            </h4>
            <div style={{ textAlign: "left", marginTop: "15px" }}>{tech}</div>
          </VerticalTimelineElement>
        );
      });

      return (
        <section id="resume" className="pb-5">
          <div className="col-md-12 mx-auto">
            <h1 className="section-title" style={styles.sectionTitle}>
              {sectionName}
            </h1>
          </div>
          <div className="col-md-8 mx-auto">
            <VerticalTimeline>
              {work}
              <VerticalTimelineElement
                iconStyle={styles.iconStyle}
                icon={
                  <i className="fas fa-hourglass-start mx-auto experience-icon"></i>
                }
              />
            </VerticalTimeline>
          </div>
        </section>
      );
    }
    return null;
  }
}

export default Experience;
